module.exports = __webpack_public_path__ + "img/meter-off-red.80f9787d.svg";